/* eslint-disable */
import jQuery from 'jquery';

jQuery(function($) {
  $('.clipboard').on('click', function() {
    let textConfirmation = $(this).parent().find(".card-item-link-confirmation").html();
    console.log(textConfirmation);

    if ($(this).children().length > 0 ) {
      $(this).children().html(textConfirmation);
    } else {
      $(this).html(textConfirmation);
    }
  })
})
